import React from 'react'
import License from './license'
import ExportLicenseComp from './exportLicenseComp'

function Calendar() {
  return (
    <div>
        <ExportLicenseComp/>
        
        <License />
    </div>
  )
}

export default Calendar